"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "CreateStepContentModel", {
    enumerable: true,
    get: function() {
        return CreateStepContentModel;
    }
});
const _stepcontentmodel = require("./step-content-model");
const CreateStepContentModel = _stepcontentmodel.StepContentModel.pick({
    languageCode: true,
    name: true,
    description: true,
    tools: true
});

//# sourceMappingURL=create-step-content-model.js.map